// extracted by mini-css-extract-plugin
export default {"container":"emailVerification_container__kL8iN"};